import { Typography, useTheme } from '@material-ui/core';

import { getColor } from '../../theme/styles';
import { useStyles } from './styles';

/**
 * `info` states the value a setting currently holds, `on`/`off` whether a switchable
 * feature is running. Every settings card shows one, so the current value can be read
 * without opening the card.
 */
export type SettingsStatusTone = 'info' | 'on' | 'off' | 'warning' | 'error';

interface Props {
  label: string;
  tone?: SettingsStatusTone;
}

export const SettingsStatusPill = ({ label, tone = 'info' }: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const colors = getColor(theme.palette.type === 'dark');

  const tones: Record<SettingsStatusTone, { background: string; color: string }> = {
    info: { background: colors.pillInfoBG, color: colors.pillInfoText },
    on: { background: colors.pillOnBG, color: colors.pillOnText },
    off: { background: colors.pillOffBG, color: colors.pillOffText },
    warning: { background: colors.pillWarnBG, color: colors.pillWarnText },
    error: { background: colors.pillErrorBG, color: colors.pillErrorText },
  };

  return (
    <Typography component="span" className={classes.pill} style={tones[tone]}>
      {label}
    </Typography>
  );
};
